<template>
  <div class="memberCenter_wrap ChangeInform" :style="{ height: height }">
    <div class="nav_pos mb_nav_pos">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><router-link to="/MemberCenter">首页</router-link></el-breadcrumb-item>
        <el-breadcrumb-item>上传发票</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="change_inform">
      <div class="title">基本信息</div>
      <div>
        <el-form :inline="true" :model="invoiceData" class="form_table el-form form_table1" ref="form" :inline-message="true">
          <el-form-item label="甲方名称">
            <span>{{ invoiceData.CompanyName }}</span>
          </el-form-item>
          <el-form-item label="合同编号">
            <span>{{ invoiceData.ContractNumber }}</span>
          </el-form-item>
          <el-form-item label="合同总价（元）">
            <span>{{ invoiceData.ContractFee }}</span>
          </el-form-item>
          <el-form-item label="甲方税号">
            <span>{{ invoiceData.SocialCreditCode }}</span>
          </el-form-item>
          <el-form-item label="甲方公司地址">
            <span>{{ invoiceData.ContactAddress }}</span>
          </el-form-item>
          <el-form-item label="甲方电话">
            <span>{{ invoiceData.ContactMobile }}</span>
          </el-form-item>
          <el-form-item label="甲方开户行">
            <span>{{ invoiceData.BankAccountName }}</span>
          </el-form-item>
          <el-form-item label="甲方银行账号">
            <span>{{ invoiceData.BankAccount }}</span>
          </el-form-item>
          <el-form-item label="发票上传日期">
            <span>{{ invoiceData.CreateDate }}</span>
          </el-form-item>
          <el-form-item label="发票快递收件信息" class="all_line">
            <span>{{ invoiceData.InvoiceAddress }}</span>
          </el-form-item>
          <el-form-item label="特别说明" class="all_line">
            <span>{{ invoiceData.Remark }}</span>
          </el-form-item>
        </el-form>
      </div>
      <div class="title">已上传发票信息</div>
      <table class="statistics_table">
        <tbody>
          <tr>
            <th width="60px">序号</th>
            <th width="120px"><label class="start">*</label>发票类型</th>
            <th width="250px"><label class="start">*</label>开票日期</th>
            <th width="150px"><label class="start">*</label>开票金额</th>
            <th width="250px">寄件日期</th>
            <th width="150px">发票快递单号</th>
            <th width="250px">上传发票</th>
          </tr>
          <template v-for="(data, index) in fileInvoiceData">
            <tr :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ data.InvoiceTypeName }}</td>
              <td>{{ data.InvoiceDate }}</td>
              <td>{{ data.InvoiceAmount1 }}</td>
              <td>{{ data.SendingDate }}</td>
              <td>{{ data.ExpressNumber }}</td>
              <td>
                <div v-for="(item1, index1) in data.InvoiceAttach" :key="index1">
                  <el-link class="fileName" @click="fnDownload(item1.fileId)" :underline="false"> {{ item1.name }}</el-link>
                  <el-link @click="fnReadPdf(item1.fileId)" :underline="false" style="color: #0361b1; padding-left: 15px"> 预览</el-link>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <div class="title">发票信息</div>
      <div class="btn_wrap" style="padding-left: 14px; padding-top: 10px" v-if="isDetail == 'false'">
        <el-button size="mini" type="primary" plain @click="add">新增</el-button>
        <el-button size="mini" type="primary" plain @click="del">删除</el-button>
      </div>
      <el-form class="rule-form" style="overflow: auto; width: 100%; margin: 0" :inline="true" :inline-message="true">
        <table class="statistics_table" v-if="isDetail == 'false'">
          <tbody>
            <tr>
              <th width="60px">
                <el-checkbox v-model="allprojectListCheck"></el-checkbox>
              </th>
              <th width="60px">序号</th>
              <th width="120px"><label class="start">*</label>发票类型</th>
              <th width="250px"><label class="start">*</label>开票日期</th>
              <th width="150px"><label class="start">*</label>开票金额</th>
              <th width="250px">寄件日期</th>
              <th width="150px">发票快递单号</th>
              <th width="250px">上传发票</th>
            </tr>
            <template v-for="(data, index) in invoiceData.DetailList">
              <tr :key="index">
                <td>
                  <el-checkbox v-model="data.Check"></el-checkbox>
                </td>
                <td>{{ index + 1 }}</td>
                <td>
                  <el-select v-model="data.InvoiceType">
                    <el-option v-for="(item1, index1) in invoiceTypeList" :key="index1" :label="item1.Text" :value="item1.Value"> </el-option>
                  </el-select>
                </td>
                <td>
                  <el-date-picker
                    v-model="data.InvoiceDate"
                    type="date"
                    placeholder="开票日期"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                  ></el-date-picker>
                </td>
                <td>
                  <el-input-number v-model="data.InvoiceAmount" :min="0" :controls="false" :precision="2" label="开票金额"></el-input-number>
                </td>
                <td>
                  <el-date-picker v-model="data.SendingDate" type="date" placeholder="寄件日期" value-format="yyyy-MM-dd"></el-date-picker>
                </td>
                <td>
                  <el-input v-model="data.ExpressNumber" placeholder="发票快递单号"></el-input>
                </td>
                <td>
                  <el-upload
                    action="#"
                    :before-remove="removeConfirm"
                    :on-change="fileChange"
                    :on-exceed="exceedFile"
                    :on-success="handleSuccess"
                    :on-error="handleError"
                    :auto-upload="true"
                    :file-list="data.InvoiceAttach"
                    :data="{ id: index }"
                    :http-request="uploadFile"
                    :before-upload="handleBeforeUpload"
                    ref="uploader"
                    :on-remove="
                      (file, fileList) => {
                        handleRemove(file, fileList, index)
                      }
                    "
                  >
                    <el-button size="mini" type="primary" plain>点击上传</el-button>
                  </el-upload>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
        <table class="statistics_table" v-if="isDetail == 'true'">
          <tbody>
            <tr>
              <th width="60px">序号</th>
              <th width="120px"><label class="start">*</label>发票类型</th>
              <th width="250px"><label class="start">*</label>开票日期</th>
              <th width="150px"><label class="start">*</label>开票金额</th>
              <th width="250px">寄件日期</th>
              <th width="150px">发票快递单号</th>
              <th width="250px">上传发票</th>
            </tr>
            <template v-for="(data, index) in invoiceData.DetailList">
              <tr :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ data.InvoiceTypeName }}</td>
                <td>{{ data.InvoiceDate }}</td>
                <td>{{ data.InvoiceAmount1 }}</td>
                <td>{{ data.SendingDate }}</td>
                <td>{{ data.ExpressNumber }}</td>
                <td>
                  <div v-for="(item1, index1) in data.InvoiceAttach" :key="index1">
                    <el-link class="fileName" @click="fnDownload(item1.fileId)" :underline="false"> {{ item1.name }}</el-link>
                    <el-link @click="fnReadPdf(item1.fileId)" :underline="false" style="color: #0361b1; padding-left: 15px"> 预览</el-link>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </el-form>

      <div class="btn_wrap changeInform_btn_wrap">
        <span class="btn_1" @click="fnGoBack()">返回</span>
        <span v-if="isDetail == 'false'" class="btn_1" @click="fnSave()">提交</span>
        <span v-if="invoiceData.AuditState == 1" class="btn_1" @click="fnRevokeFlow()">撤回流程</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      uploadUrl: '',
      contractId: this.$route.query.contractId,
      invoiceId: this.$route.query.invoiceId,
      isDetail: this.$route.query.isDetail,
      allprojectListCheck: '',
      invoiceData: {},
      fileInvoiceData: [],
      invoiceTypeList: [],
      height: '0px',
      pickerOptions: {
        disabledDate(time) {
          let date = new Date()
          return time.getTime() > Date.now()
        }
      }
    }
  },
  watch: {
    allprojectListCheck(val) {
      this.invoiceData.DetailList.forEach((element) => {
        if (element.hasOwnProperty('Check') && !element.IsScelect) {
          element.Check = val
        }
      })
    }
  },
  mounted() {
    console.log(this.isDetail)
    let change_inform = document.getElementsByClassName('MemberHeader')[0]
    this.height = window.innerHeight - change_inform.clientHeight - 17 + 'px'
    this.getData()
  },
  methods: {
    getData() {
      let config = {
        params: {
          contractId: this.contractId,
          invoiceId: this.invoiceId,
          isDetail: this.isDetail
        }
      }
      this.getRequest('/Contract/GetInvioiceData', config).then((res) => {
        if (res.data.errcode == 0) {
          this.invoiceData = res.data.invoiceData
          this.invoiceTypeList = res.data.invoiceTypeList
          this.fileInvoiceData = res.data.fileInvoiceData
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },
    fnGoBack() {
      window.close()
    },

    uploadFile(params) {
      console.log(params)
      let file = params.file
      var data = new window.FormData()
      let loginToken = window.localStorage.getItem('loginToken')
      data.append('file', params.file)
      data.append('loginToken', loginToken)
      this.uploadFileRequest('/Common/UploadFile', data).then((res) => {
        if (res.data.errcode == 0) {
          console.log(res.data)
          let obj = {
            fileId: res.data.FileList[0].id,
            name: res.data.FileList[0].fileName
          }

          if (this.invoiceData.DetailList[params.data.id].InvoiceAttach.length == 0) {
            var fileList = [obj]
            this.invoiceData.DetailList[params.data.id].InvoiceAttach = fileList
          } else {
            this.invoiceData.DetailList[params.data.id].InvoiceAttach.push(obj)
          }
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },
    exceedFile(files, fileList) {
      this.$message({
        showClose: true,
        message: `最多上传100个文件`,
        type: 'warning'
      })
    },
    // 文件状态改变时的钩子
    fileChange(file, fileList) {},
    // 点击x时执行的钩子函数
    removeConfirm(file, fileList) {
      if (file.status == 'success') {
        return this.$confirm(`确定删除 ${file.name}？`)
      }
    },
    handleRemove(file, fileList, index) {
      console.log(file, fileList, index)
      if (file.hasOwnProperty('fileId')) {
        this.postRequest('/Common/DeleteAttachmentByFileId', {
          fileId: file.fileId
        }).then((res) => {
          if (res.data.errcode == 0) {
            this.invoiceData.DetailList[index].InvoiceAttach = this.invoiceData.DetailList[index].InvoiceAttach.filter((item1) => {
              return item1.uid != file.uid
            })
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
      }
      console.log(this.projectList)
    },
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      if (response.errcode == 0) {
        this.fileList = fileList
        // this.fileIds.push(response.fileId);
        this.$notify.success({
          title: '上传结果',
          message: `${file.name}上传成功`,
          position: 'bottom-right'
        })
      } else {
        this.$notify.error({
          title: '上传结果',
          message: `${file.name}上传失败:${response.errmsg}`,
          position: 'bottom-right'
        })
      }
    },
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$notify.error({
        title: '上传结果',
        message: `${file.fileName}上传失败:{err}`,
        position: 'bottom-right'
      })
    },
    handleBeforeUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      if (testmsg !== 'pdf' && testmsg !== 'PDF') {
        this.$message.error('请上传pdf文件!')
        return false
      }
    },
    add() {
      var data = {
        Check: false,
        SendingDate: '',
        ExpressNumber: '',
        InvoiceType: '',
        InvoiceDate: '',
        InvoiceAmount: this.invoiceData.ContractFee,
        InvoiceAttach: []
      }
      this.invoiceData.DetailList.push(data)
    },
    del() {
      this.invoiceData.DetailList = this.invoiceData.DetailList.filter((item) => {
        return item.Check == false
      })
    },
    fnSave() {
      let flag = true
      let that = this
      if (this.invoiceData.DetailList.length == 0) {
        that.$message.error(`请添加发票记录！`)
        flag = false
        return false
      }
      this.invoiceData.DetailList.forEach((item, index) => {
        if ((item.InvoiceType == '' || item.InvoiceType == null) && flag) {
          that.$message.error(`请选择发票记录${index + 1}的发票类型`)
          flag = false
          return false
        }
        if ((item.InvoiceDate == '' || item.InvoiceDate == null) && flag) {
          that.$message.error(`请填写发票记录${index + 1}的开票时间`)
          flag = false
          return false
        }
        if ((item.InvoiceAmount == '' || item.InvoiceAmount == null) && flag) {
          that.$message.error(`请填写发票记录${index + 1}的开票金额`)
          flag = false
          return false
        }
        if (item.InvoiceAmount <= 0 && flag) {
          that.$message.error(`发票记录${index + 1}的开票金额需大于0`)
          flag = false
          return false
        }
        if (item.InvoiceType == 1 && flag && (item.SendingDate == '' || item.SendingDate == null)) {
          that.$message.error(`请填写发票记录${index + 1}的寄件日期`)
          flag = false
          return false
        }
        if (item.InvoiceType == 1 && flag && (item.ExpressNumber == '' || item.ExpressNumber == null)) {
          that.$message.error(`请填写发票记录${index + 1}的发票快递单号`)
          flag = false
          return false
        }
        if (item.InvoiceAttach.length == 0 && flag) {
          that.$message.error(`请上传发票记录${index + 1}的开票附件`)
          flag = false
          return false
        }
      })
      if (flag) {
        this.postRequest('/Contract/SaveInvioiceData', {
          contractId: this.contractId,
          invoiceDataJson: JSON.stringify(this.invoiceData)
        }).then((res) => {
          if (res.data.errcode == 0) {
            this.$message.success('提交成功')
            window.close()
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
      }
    },
    fnRevokeFlow() {
      this.$confirm('是否确认撤销流程', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        //确认撤标
        this.postRequest('/Common/RevokeFlow', {
          flowCode: '2943',
          fkValue: this.invoiceId
        })
          .then((res) => {
            var data = res.data
            if (data.errcode == 0) {
              this.$message.success('撤销成功')
              this.isDetail = false
              this.getData()
            } else {
              this.$message.error(data.errmsg)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      })
    },
    fnDownload(fileId) {
      let token = window.localStorage.getItem('loginToken')
      var url = '/Common/DownloadFile?FileId=' + fileId + '&token=' + token + '&FileName='
      this.downloadfile(this.baseURL + url)
    },
    fnReadPdf(fileId) {
      let routerData = this.$router.resolve({
        path: 'ReadPDF',
        query: {
          fileId: fileId
        }
      })
      window.open(routerData.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.content_wrap {
  padding-bottom: 20px;
  margin-bottom: 20px;
}
.changeInform_btn_wrap {
  width: 366px;
  margin: 40px auto 0;
  .btn_1 {
    background: #055ba9;
    color: #fff;
    border: none;
  }
}
.supplierType {
  .el-form-item {
    display: inline-block;
    flex: 0 0 200px;
    .el-input {
      width: 200px;
    }
  }
  .supplierOtherType {
    ::v-deep.el-form-item__content {
      border-bottom: none;
    }
  }
}
::v-deep.businessTermDate {
  .el-form-item__content {
    align-items: center;
  }
  .term {
    margin-top: 0 !important;
    margin-left: 0 !important;
  }
  .el-input {
    width: 300px;
    margin-right: 8px;
  }
  .businessTermEndDate {
    margin-bottom: 0 !important;
    .el-input {
      width: 100% !important;
    }
    .el-form-item__label:before {
      display: none;
    }
    .el-form-item__content {
      border-bottom: none;
    }
  }
}
::v-deep.el-form-item {
  .el-input.is-disabled .el-input__inner,
  .el-select .el-input.is-disabled .el-input__inner,
  .el-checkbox__input.is-disabled + span.el-checkbox__label,
  .el-textarea.is-disabled .el-textarea__inner {
    color: #606266;
  }
}
.back_btn {
  height: 26px;
  bottom: 7px;
  padding: 0 18px;
  border-radius: 14px;
}
.businessTermDate1 ::v-deep.el-input__inner {
  min-width: 150px !important;
}

.tableWrap5_custom ::v-deep.btn_wrap {
  margin-right: 12px;
  margin-top: 15px;
}
.tableWrap5_custom ::v-deep.tab_wrap5 {
  margin: 0 15px 15px;
  .product_form {
    margin-bottom: 0;
  }
}
.change_inform ::v-deep.icon_tips2 {
  vertical-align: middle !important;
}
.rangeDate ::v-deep.el-form-item__content {
  .el-input__inner,
  .el-range-editor {
    width: 300px;
    margin-right: 8px;
    text-align: center;
    .el-range-input {
      font-size: 14px;
    }
  }
}
.tree ::v-deep .el-tree-node {
  .el-tree-node__children {
    white-space: normal;
    .el-tree-node {
      display: inline-block;
    }
  }
}
.otherinput {
  height: 25px;
  line-height: 40px;
  width: 100%;
}
.width_full {
  width: 100% !important;
}

.statistics_table {
  width: 98.5%;
  table-layout: fixed;
  th {
    padding: 6px 0;
    text-align: center !important;
    background: #d8eafa !important;
    color: #046663;
    font-weight: normal !important;
    border: 1px solid #95c7f0;
    vertical-align: middle;
    white-space: nowrap;
  }
  td {
    padding: 6px 12px;
    border: 1px solid #95c7f0;
    background: #fff !important;
    text-align: center;
  }
  tr {
    border-bottom: 1px solid #95c7f0;
  }
}
.file_wrap {
  width: 18rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.form_table1 {
  .el-form-item {
    flex: 33.3%;
  }
  .all_line {
    flex: 0 0 100%;
  }
}
.start {
  vertical-align: middle;
  color: #f56c6c;
  display: inline-block;
  margin-right: 4px;
}
</style>
